import '../../util/string';
import { CircularProgress, Fab, Tooltip, Typography } from '@material-ui/core/';
import Grid from '@material-ui/core/Grid';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import Moment from 'moment';
import MUIDataTable from 'mui-datatables';
import PropTypes from 'prop-types';
import React, { forwardRef, useEffect, useState, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import QueryString from 'querystring';
import { withRouter, useHistory } from 'react-router-dom';
import Url from 'url';
import join from 'url-join';
import axios from '../../axios-default';
//Components
import SideNav from '../../components/Admin/SideNav';
import { ApiServerUrl } from '../../config.json';
import { easySnackbar } from '../../store/Noti/noti.actions';
import { updateRes } from '../../store/res/res.action';
import { getFromObj } from '../../util/lang';
import { get } from 'http';

import Add from '@material-ui/icons/Add';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import DraftsIcon from '@material-ui/icons/Drafts';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import GridOnIcon from '@material-ui/icons/GridOn';
import LastPage from '@material-ui/icons/LastPage';
import MailOutlinedIcon from '@material-ui/icons/MailOutlined';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import ViewListIcon from '@material-ui/icons/ViewList';
import MaterialTable from 'material-table';

import { getWebAbsPath } from '../../util/path';

const TableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const CaseStyles = makeStyles((theme) => ({
    '@global': {
        body: {
            background: '#fdfdfd',
        },
    },
    root: {
        flexGrow: 1,
    },
    rootContainer: {
        padding: 16,
        margin: '8px 0px 0px 238px',
        [theme.breakpoints.between('xs', 'sm')]: {
            margin: '12px 0px 0px 0px',
            width: '100%',
        },
        width: 'calc(100% - 238px)',
    },
    scanBox: {
        padding: 16,
        margin: '8px 0px',
    },
    textField: {
        // marginLeft: "8px",
        // marginRight: "8px",
        '& label.Mui-focused': {
            color: 'black',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'black',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'grey',
            },
            '&:hover fieldset': {
                borderColor: 'black',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'black',
            },
        },
    },
    dateField: {
        width: '100%',
    },
    formControl: {
        width: '100%',
    },
    dense: {
        marginTop: 16,
        marginLeft: 0,
    },
    submitBtn: {
        backgroundColor: '#061a2e !important',
        color: 'white',
        padding: '8px 24px',
        margin: '12px 0px',
    },
    linkBtn: {
        background: 'rgba(89,54,135,1)',
        color: 'white',
        padding: '4px 24px',
        fontWeight: 300,
        margin: '16px 0px',
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            padding: '4px 72px',
            width: 'unset',
        },
        '&:hover': {
            background: 'rgb(77, 74, 142)',
            color: 'white',
        },
    },
}));
const columns = [
    {
        name: 'id',
        label: 'ID',
    },

    {
        name: 'created_date',
        label: 'Date',
    },
    {
        name: 'created_by',
        label: 'User',
    },
    {
        name: 'platform',
        label: 'Platform',
    },
    {
        name: 'module',
        label: 'Module',
    },
    {
        name: 'action',
        label: 'Action',
    },
    {
        name: 'para1',
        label: 'Parameter 1',
    },
    {
        name: 'para2',
        label: 'Parameter 2',
    },
    {
        name: 'para3',
        label: 'Parameter 3',
    },
    {
        name: 'para4',
        label: 'Parameter 4',
    },
    {
        name: 'para5',
        label: 'Parameter 5',
    },
    {
        name: 'detail',
        label: 'Detail',
    },
];

const options = {
    filter: true,
    selectableRows: 'none', // You can change this based on your needs
    viewColumns: false,
    responsive: 'standard',
    rowsPerPage: 10,
    minHeight: '300px', // Set the minimum body height
    maxHeight: '10000px', // Set the maximum body height
};

export default function TraceLog(props) {
    const classes = CaseStyles(),
        dispatch = useDispatch(),
        history = useHistory();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false),
        lastPageSize = useRef(),
        lastPageNo = useRef(0),
        [total, setTotal] = useState(0);

    useEffect(() => {
        fetchData({ pageSize: 10, page: 0 });
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    const reloadPage = () => {
        history.push('/blank');
        history.replace(history.location.pathname);
    };

    const fetchData = async (query) => {
        const { pageSize, page: pageNo, search, orderBy, orderDirection } = query;

        try {
            if (orderBy && orderBy.field.endsWith('_label')) {
                orderBy.field = orderBy.field.slice(0, -6);
            }

            const queryParams = QueryString.stringify({
                searchStr: typeof search !== 'string' || String.isBlank(search) ? undefined : search,
                sortBy: orderBy && orderBy.field,
                sortDir: orderDirection,
                statusFilter: 'ALL',
                pageSize,
                pageNo,
                all: 1,
            });

            const response = await axios.get(`/case/trace/traceLog?${queryParams}`);
            const responseData = response.data;

            const formattedData = responseData.case.map((c) => ({
                id: c.id,
                para1: c.para1,
                para2: c.para2,
                para3: c.para3,
                para4: c.para4,
                para5: c.para5,
                detail: c.detail,
                platform: c.platform,
                module: c.module,
                action: c.action,
                created_by: c.created_by,
                created_date: Moment(c.created_date).calendar({
                    sameElse: 'DD MMM YYYY [at] hh:mm A',
                }),
            }));

            setData(formattedData);
            setLoading(false);
        } catch (err) {
            console.error(err);
            if (err.response && err.response.statusText === 'Unauthorized') {
                localStorage.removeItem('auth-token');
                localStorage.removeItem('expirationDate');
                localStorage.removeItem('role');
                history.replace('/login');
            }
        }
    };

    return (
        <div>
            <SideNav />
            <Grid container className={classes.rootContainer}></Grid>
            <Grid container className={classes.rootContainer} style={{ marginTop: 0 }}>
                {!loading ? (
                    <div style={{ display: 'contents' }}>
                        <Grid container>
                            <Grid
                                item
                                xs={12}
                                style={{
                                    padding: 8,
                                }}
                            >
                                <h1
                                    style={{
                                        marginBlockEnd: 0,
                                    }}
                                >
                                    Audit Trail
                                </h1>

                                <hr />
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                style={{
                                    padding: 8,
                                    textAlign: 'center',
                                }}
                            >
                                <img
                                    style={{ width: '100%', maxWidth: 800 }}
                                    src={getWebAbsPath('/img/account1.png')}
                                />
                            </Grid>

                            <Grid item xs={12} style={{ padding: 8 }}>
                                <MUIDataTable
                                    title={'Audit Trial'}
                                    data={data}
                                    columns={columns}
                                    options={options}
                                    minBodyHeigh={700}
                                    maxBodyHeight={1000}
                                />
                            </Grid>
                        </Grid>
                    </div>
                ) : (
                    <Grid container style={{ display: 'flex', justifyContent: 'center' }}>
                        <CircularProgress style={{ color: 'rgb(6,26,46)' }} />
                    </Grid>
                )}
            </Grid>
        </div>
    );
}
